var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13h5v-2h-5v2zm0-3h5V8h-5v2zm-9 6h8v-.55c0-.75-.367-1.346-1.1-1.787C11.167 13.22 10.2 13 9 13s-2.167.22-2.9.662C5.367 14.104 5 14.7 5 15.45V16zm4-4c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 009 8c-.55 0-1.02.196-1.412.588A1.926 1.926 0 007 10c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588zm-5 8c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 014 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0120 20H4z"
  })));
}
export default Svg24Px;